import { BASIC_AUTH_HEADER, mainServer } from "../../../variables/config";

const params = {limit:100, offset:0, order:1, order_by:'title'}

export const request_products = async(tags) => {
    mainServer.defaults.headers.common['Authorization'] = BASIC_AUTH_HEADER
    const response = await mainServer.get("/product/all", {params:{...params, category:tags}})
    return response.data.data
}